import { modules, modulesMetaData } from '../../components/CrossModuleLink/modules';
import { getPageUrl } from '../../components/CrossModuleLink/utils';
import { CustomObject } from '../../types';

export const getPublicJobListUrl = (params?: CustomObject): string => {
	return getPageUrl({
		module: modules.PUBLIC_JOB,
		route: modulesMetaData[modules.PUBLIC_JOB].list,
		params,
	});
};
